import { createSelector } from '@reduxjs/toolkit';
import { IInitialState } from 'types';

const integrations = (r: IInitialState) => r.integrations;
export const credentialsSelector = createSelector(
  integrations,
  r => r.credentials
);




